// import { makeStyles } from "@mui/styles";
// import { createStyles, Theme } from "@mui/material/styles";

import {
    Backdrop,
    CircularProgress, SxProps, Typography
} from "@mui/material";

// const useStyles: any = makeStyles((theme: Theme) => createStyles({
//     backdrop: {
//         zIndex: 100000,
//         backgroundColor: 'rgba(0,0,0, 0.6)'
//     },
//     titleGreetingWelcome: {
//         alignSelf: 'center',
//         fontWeight: '600 !important',
//         fontSize: '24px !important'
//     },
//     containerCircularProgress: {
//         justifyContent: 'center'
//     }
// }));


interface LoaderBlockUIProps {
    message?: string,
    sxProps?: SxProps
}

export function LoaderBlockUI(props: LoaderBlockUIProps) {

    // const classes = useStyles();

    return (
        <Backdrop sx={{
            zIndex: 100000,
            color: '#3498db',
            backgroundColor: 'rgba(0,0,0, 0.6)',
            borderTop: '2px solid #3498db',
            ...props.sxProps
        }} open={true}>
            <CircularProgress color="inherit" size={100} value={100}/>
            <Typography variant="h5" sx={{
                position: 'absolute',
                top: '55%',
                color: 'white'
            }}>{props.message}</Typography>
        </Backdrop>
    );
}